// https://stackoverflow.com/questions/2304941/what-is-the-non-jquery-equivalent-of-document-ready
// Voir 2e réponses
export default function(callback) {
    document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};
